import React, { useEffect, useState } from "react";
import { useCart } from "../context/CartContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useApi } from "../utils/Api";

function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const { apiFetch } = useApi();

  const [trackingEncryptedId, setTrackingEncryptedId] = useState(null);

  const params = new URLSearchParams(location.search);
  const encryptedOrderId = params.get("order");

  const trackingUrl = trackingEncryptedId
    ? `${window.location.origin}/order-tracking?id=${trackingEncryptedId}`
    : null;

  useEffect(() => {
    if (!encryptedOrderId) return;

    const markPaid = async () => {
      try {
        const result = await apiFetch("mark-order-paid", {
          encrypted_order_id: encryptedOrderId,
        });

        if (result?.tracking_encrypted_order_id) {
          setTrackingEncryptedId(result.tracking_encrypted_order_id);
        }

        if (!result?.success) {
          console.error("Failed to mark order paid:", result?.message);
        }
      } catch (err) {
        console.error("Network error:", err);
      }
    };

    markPaid();
  }, [encryptedOrderId, apiFetch]);

  useEffect(() => {
    if (!encryptedOrderId) {
      navigate("/", { replace: true });
      return;
    }

    clearCart();
  }, [encryptedOrderId, clearCart, navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>✅ Payment Successful</h1>

        <p style={styles.text}>
          Thank you for your order. Your payment has been received successfully.
        </p>

        <p style={styles.text}>
          Your order is now being processed. You can track its progress below.
        </p>

        {trackingUrl && (
          <a
            href={trackingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="add-to-cart-button"
            style={styles.button}
          >
            Click here to track your order
          </a>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "65vh",
    display: "flex",
    marginTop: "7rem",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f7f7f7",
    padding: "1rem",
  },
  card: {
    background: "#ffffff",
    padding: "2rem",
    borderRadius: "8px",
    maxWidth: "500px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.08)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    marginBottom: "1.5rem",
    color: "#2e7d32",
  },
  text: {
    marginBottom: "0.75rem",
    color: "#444",
    fontSize: "0.95rem",
  },
  button: {
    marginTop: "1.5rem",
    padding: "0.7rem 1.2rem",
    textDecoration: "none",
  },
};

export default PaymentSuccess;